/* eslint-disable no-undef */
import styles from './index.module.less';
import dynamic from 'next/dynamic';
const Header = dynamic(() => import('./cpns/Header'), {
  ssr: true,
});

const MainFunc = dynamic(() => import('./cpns/MainFunc'), {
  ssr: true,
});

const WhatIsDmca = dynamic(() => import('./cpns/WhatIsDmca'), {
  ssr: true,
});
const Earth = dynamic(() => import('./cpns/Earth'), {
  ssr: true,
});
const DmcaProcess = dynamic(() => import('./cpns/DmcaProcess'), {
  ssr: true,
});
const TwoBlogSec = dynamic(() => import('@/components/Common/TwoBlogSec'), {
  ssr: true,
});

const FreQuestion = dynamic(() => import('./freQuestions/index'), {
  ssr: true,
});
const SectionList = dynamic(() => import('./cpns/SectionList'), {
  ssr: true,
});
const CustomersTalkUsContent = dynamic(() => import('@/components/Common/CustomersTalkUsContent'), {
  ssr: true,
});

const Index: React.FC<{ data: any }> = ({ data }) => {
  // eslint-disable-next-line no-console
  console.log(data.data);
  return (
    <div className={styles.container}>
      <Header data={data.data} />
      <div className={styles.main}>
        <MainFunc />
        <WhatIsDmca data={data.data} />
        <Earth data={data.data} />
        <DmcaProcess data={data.data} />
        <TwoBlogSec
          blogList={data.data.blogList}
          topBlogList={data.data.topBlogList}
          blogTitle={data.data.contentInfo['section-blog']?.title}
          topBlogTitle={data.data.contentInfo['section-top-blog']?.title}
        />
        {data.data.contentInfo['section-testimonial']?.title && (
          <CustomersTalkUsContent content={data.data.contentInfo['section-testimonial']} />
        )}
        <FreQuestion data={data.data} />
        <SectionList data={data.data} />
      </div>
    </div>
  );
};

export default Index;
